import {
  BubbleChart,
  Group,
  PeopleOutline,
  People,
  SupervisedUserCircle,
  Dashboard as DashboardIcon,
  EventAvailable,
  BarChart,
  AttachMoney,
  SettingsApplications,
  Business as BusinessIcon,
  Payment as PaymentIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Computer as ComputerIcon,
  Subscriptions as SubscriptionsIcon,
  Language as ConnectIcon,
  ReportProblem as ReportProblemIcon
} from "@material-ui/icons";
import AssessmentIcon from '@material-ui/icons/Assessment';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';

import React from 'react';

import Login from "views/Auth/Login.js";
import Signup from "views/Auth/Signup.js";
import ForgotPassword from "views/Auth/ForgotPassword.js";

import Home from "views/Home/Home";
import Dashboard from "views/Dashboard/Dashboard";
import OnBoard from "views/User/OnBoard";

import { ADMIN_PERMISSIONS, CLIENT_TYPE, SYSTEM_ROLE } from "config/AppConfig";

import { ReactComponent as HouseIcon } from "assets/icons/house.svg";
import { ReactComponent as ListIcon } from "assets/icons/list.svg";
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { ReactComponent as DollarIcon } from "assets/icons/dollar.svg";
import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";
import { ReactComponent as SettingIcon } from "assets/icons/setting.svg";
import { ReactComponent as PencilIcon } from "assets/icons/pencil.svg";
import { ReactComponent as InfoIcon } from "assets/icons/info-circle.svg";
import { ReactComponent as QuestionIcon } from "assets/icons/question-circle.svg";
import { ReactComponent as SettingsAccount } from "assets/icons/settings-account-icon.svg";

import ClientManagement from "../views/Admin/ClientManagement";
import CreateParticipants from "../views/Admin/Component/Client/CreateParticipants";
import RateManagement from "views/Admin/RateManagement";
import RateDetail from "views/Admin/Component/Rate/RateDetail";
import PayrollManagement from "views/Admin/Component/Payroll/PayrollTable";
import PayrollDetail from "views/Admin/Component/Payroll/PayrollDetail";
import ClientDetail from "views/Admin/Component/Client/ClientDetail";
import WorkerManagement from "../views/Admin/WorkerManagement";
import ClientUserManagement from "../views/Client/User/ClientUserManagement";
import ClientBookingTable from "views/Client/ClientBooking/Components/ClientBookingTable";
import ClientBookingDetail from "views/Client/ClientBooking/Components/ClientBookingForm";
import SearchWorker from "views/Client/SearchWorker/SearchWorker";
import StaffDetail from "views/Admin/Component/Staff/StaffDetail";
import StaffCreate from "views/Admin/Component/Staff/StaffCreate";
import WorkerDetail from "views/Admin/Component/Worker/WorkerDetail";
import ProfileManagement from "views/Admin/ProfileManagement";
import AdminUserManagement from "../views/Admin/AdminUser/AdminUserManagement";
import AccountSetting from "views/Client/AccountSetting/AccountSetting";
import AdminUserDetail from "../views/Admin/AdminUser/AdminUserDetail";
import { Redirect } from "react-router-dom";
import SearchWorkerDetail from "../views/Client/SearchWorker/SearchWorkerDetail";
import WorkerPublicDetail from "../views/Client/SearchWorker/WorkerPublicDetail";
import OptionManagement from "../views/Admin/OptionManagement";
import BillingManagement from "../views/Admin/BillingManagement";
import BillingDetail from "../views/Admin/Component/Billing/BillingDetail";
import JobForm from "views/Client/Job/Components/JobForm";
import JobTable from "views/Client/Job/Components/JobTable";
import ParticipantForm from "views/Client/Participant/Components/ParticipantForm";
import ParticipantListTable from "views/Client/Participant/Components/ParticipantListTable";
import UserTable from "views/Client/User/Components/UserTable";
import UserForm from "views/Client/User/Components/UserForm";
import CompanyManagement from "views/Admin/CompanyManagement";
import CompanyDetailForm from "views/Admin/Component/Company/CompanyDetailForm";
import SubscriptionPlanManagement from "views/Admin/SubscriptionPlanManagement";
import SubscriptionManagement from "views/Admin/SubscriptionManagement";
import TransactionManagement from "views/Admin/TransactionManagement";
import AccountSoftwareManagement from "views/Admin/AccountSoftwareManagement";
import PaymentGatewayManagement from "views/Admin/PaymentGatewayManagement";
import JobManagement from "views/Admin/JobManagement";
import JobDetail from "views/Company/Jobs/JobDetail";
import SubscriptionPlanDetail from "views/Admin/Component/SubscriptionPlan/SubscriptionPlanDetail";
import SubscriptionDetail from "views/Admin/Component/Subscription/SubscriptionDetail";
import AccountingAccountForm from "views/Company/AccountSetting/Components/AccountingAccountForm";
import ClientDetailTabs from "views/Admin/Component/Client/ClientDetailTabs";
import TimesheetManagement from "views/Admin/TimesheetManagement";
import TimesheetDetail from "views/Admin/Component/Financial/Timesheet/TimesheetDetail";
import ComplaintDetail from "views/Admin/Component/Complaints/ComplaintDetail";
import ComplaintTable from "views/Admin/Component/Complaints/ComplaintTable";
import ActionRegisterTable from "views/Admin/Component/Complaints/ActionRegisterTable";
import IncidentTable from "views/Admin/Component/Incidents/IncidentTable";
import IncidentDetail from "views/Admin/Component/Incidents/IncidentDetail";
import InvestigationTable from "views/Admin/Component/Investigations/InvestigationTable";
import InvestigationDetail from "views/Admin/Component/Investigations/InvestigationDetail";
import PublicComplaintForm from "views/Public/ComplaintForm/PublicComplaintForm";
import IntakeLinkForm from "views/Public/IntakeLink/IntakeLinkForm";

// import CompanyAccountSetting from "views/Company/AccountSetting/AccountSetting";
const dashboardRoutes = [
  // Public Routes
  {
    path: "/complaint/form",
    name: "Public Complaint Form",
    component: PublicComplaintForm,
    layout: "/public",
    isMenu: false,
  },
  {
    path: "/intake-link/form/:token",
    name: "Intake Link Form",
    component: IntakeLinkForm,
    layout: "/public",
    isMenu: false,
  },
  // Auth Routes
  // {
  //   path: "/client/login",
  //   name: "title.login",
  //   component: Login,
  //   layout: "/auth",
  // },
  {
    path: "/worker/login",
    name: "title.login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/login",
    name: "title.login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/company/login",
    name: "title.login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/signup",
    name: "title.login",
    component: Signup,
    layout: "/auth",
  },
  {
    path: "/admin/forgot-password",
    name: "title.forgotPassword",
    component: ForgotPassword,
    layout: "/auth",
  },
  {
    path: "/worker/forgot-password",
    name: "title.forgotPassword",
    component: ForgotPassword,
    layout: "/auth",
  },
  // {
  //   path: "/client/forgot-password",
  //   name: "title.forgotPassword",
  //   component: ForgotPassword,
  //   layout: "/auth",
  // },
  {
    path: "/company/forgot-password",
    name: "title.forgotPassword",
    component: ForgotPassword,
    layout: "/auth",
  },

  // Public
  {
    path: "/home",
    name: "title.home",
    icon: BubbleChart,
    component: Home,
    layout: "/",
  },

  // User
  {
    path: "/dashboard",
    name: "title.dashboard",
    icon: HouseIcon,
    component: Home,
    layout: "/",
    accessRole: '*',
    activeStatus: false,
    isMenu: true,
  },
  {
    path: "/users",
    name: "title.users",
    icon: Group,
    component: UserTable,
    layout: "/",
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.HOSPITAL_ADMIN],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.MULTIPLE_USER_HOSPITAL],
    isMenu: true,
  },
  {
    path: "/users/create",
    name: "title.createUser",
    component: UserForm,
    layout: "/",
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.HOSPITAL_ADMIN],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.MULTIPLE_USER_HOSPITAL],
  },
  {
    path: "/users/detail/:id",
    name: "title.editUser",
    component: ClientUserManagement,
    layout: "/",
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.HOSPITAL_ADMIN],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.MULTIPLE_USER_HOSPITAL],
  },
  {
    path: "/jobs",
    name: "title.jobs",
    icon: ListIcon,
    component: JobTable,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
    isMenu: true,
  },
  {
    path: "/jobs/create",
    name: "title.createNewJob",
    component: JobForm,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true
  },
  {
    path: "/jobs/detail/:id",
    name: "title.jobDetails",
    component: JobForm,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true
  },
  {
    path: "/search-worker",
    name: "title.searchWorker",
    icon: SearchIcon,
    component: SearchWorker,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    isMenu: true,
  },
  {
    path: "/search-worker/detail/:id",
    name: "title.searchWorker",
    component: SearchWorkerDetail,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
  },
  {
    path: "/worker-profile/:id",
    name: "title.searchWorker",
    icon: SearchIcon,
    component: WorkerPublicDetail,
    activeStatus: true,
    layout: "/public",
    accessRole: '*',
    isMenu: false,
  },
  {
    path: "/booking",
    name: "title.booking",
    extraTitle: "title.bookingList",
    icon: CalendarIcon,
    component: ClientBookingTable,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
    isMenu: true,
  },
  {
    path: "/booking/:id",
    name: "title.booking",
    component: ClientBookingDetail,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
  },
  {
    path: "/participant",
    name: "title.participant",
    extraTitle: "title.participantList",
    icon: PeopleOutline,
    component: ParticipantListTable,
    layout: "/",
    activeStatus: true,
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.SINGLE_USER_COORDINATOR],
    isMenu: true,
  },
  {
    path: "/participant/create",
    name: "title.create_participant",
    component: ParticipantForm,
    layout: "/",
    activeStatus: true,
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.SINGLE_USER_COORDINATOR],
  },
  {
    path: "/participant/detail/:id",
    name: "title.edit_participant",
    component: ParticipantForm,
    layout: "/",
    activeStatus: true,
    accessRole: [SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER],
    accessClient: [CLIENT_TYPE.MULTIPLE_USER_COORDINATOR, CLIENT_TYPE.SINGLE_USER_COORDINATOR],
  },
  {
    path: "/billing",
    name: "title.billing",
    extraTitle: "title.billingList",
    icon: DollarIcon,
    component: BillingManagement,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
    isMenu: true,
  },
  {
    path: "/billing/:id",
    name: "title.billingDetails",
    component: BillingDetail,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
  },
  {
    path: "/account",
    name: "title.account_settings",
    icon: SettingIcon,
    component: AccountSetting,
    layout: "/",
    accessRole: [
      SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
      SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
      SYSTEM_ROLE.PARTICIPANT
    ],
    activeStatus: true,
    isMenu: true,
  },
  {
    path: "/help",
    name: "title.help",
    icon: QuestionIcon,
    component: Home,
    layout: "/",
    accessRole: '*',
    isMenuBottom: false,
  },
  {
    path: "/aboutUs",
    name: "title.aboutUs",
    icon: InfoIcon,
    component: Home,
    layout: "/",
    accessRole: '*',
    isMenuBottom: false,
  },
  {
    path: "/profile",
    name: "title.editProfile",
    icon: PencilIcon,
    component: OnBoard,
    layout: "/",
    isMenuTop: true,
    accessRole: '*',
  },


  // Admin
  {
    path: "/dashboard",
    name: "title.dashboard",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.dashboard.id
  },
  {
    path: "/profile",
    name: "title.profile",
    icon: PencilIcon,
    component: ProfileManagement,
    layout: "/admin",
    isMenuTop: true,
  },
  {
    path: "/users",
    name: "title.team",
    extraTitle: "title.team",
    icon: SupervisedUserCircle,
    component: AdminUserManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.users.id
  },
  {
    path: "/users/create",
    name: "title.create_user",
    icon: SupervisedUserCircle,
    component: AdminUserDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.users.id
  },
  {
    path: "/users/detail",
    name: "title.edit_user",
    icon: SupervisedUserCircle,
    component: () => <Redirect to="/admin/users" />,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.users.id
  },
  {
    path: "/users/detail/:id",
    name: "title.edit_user",
    icon: SupervisedUserCircle,
    component: AdminUserDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.users.id
  },
  // start admin menus
  {
    path: "/company",
    name: "title.companies",
    icon: BusinessIcon,
    component: CompanyManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.company.id
  },
  {
    path: "/company/create",
    name: "title.create_companies",
    icon: BusinessIcon,
    component: CompanyDetailForm,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.company.id
  },
  {
    path: "/company/create/:companyId",
    name: "title.create_companies",
    icon: BusinessIcon,
    component: CompanyDetailForm,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.company.id
  },
  {
    path: "/company/detail/:companyId",
    name: "title.edit_companies",
    icon: BusinessIcon,
    component: CompanyDetailForm,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.company.id
  },
  {
    path: "/subscription-plan",
    name: "label.subscriptionPlan",
    icon: SubscriptionsIcon,
    component: SubscriptionPlanManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.subscriptionPlan.id
  },
  {
    path: "/subscription-plan/create",
    name: "label.add_subscriptionPlan",
    icon: SubscriptionsIcon,
    component: SubscriptionPlanDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.subscriptionPlan.id
  },
  {
    path: "/subscription-plan/:id",
    name: "label.edit_subscriptionPlan",
    icon: SubscriptionsIcon,
    component: SubscriptionPlanDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.subscriptionPlan.id
  },
  {
    path: "/transactions",
    name: "label.transactions",
    icon: AccountBalanceWalletIcon,
    component: TransactionManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.transactions.id
  },
  {
    path: "/account-software",
    name: "label.accountSoftware",
    icon: ComputerIcon,
    component: AccountSoftwareManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.accountSoftware.id
  },
  {
    path: "/payment-gateway",
    name: "label.paymentGateway",
    icon: PaymentIcon,
    component: PaymentGatewayManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.paymentGateway.id
  },
  // end admin menus
  // start company menus
  {
    path: "/workers",
    name: "title.workers",
    extraTitle: "title.workers",
    icon: PeopleOutline,
    component: WorkerManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.workers.id
  },
  {
    path: "/workers/create",
    name: "title.create_worker",
    component: StaffCreate,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.workers.id
  },
  {
    path: "/workers/:id",
    name: "title.editWorker",
    component: StaffDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.workers.id
  },
  {
    path: "/participants",
    name: "title.participants",
    extraTitle: "title.participants",
    icon: People,
    component: ClientManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.clients.id
  },
  {
    path: "/participants/create",
    name: "title.create_participant",
    component: CreateParticipants,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.clients.id
  },
  // {
  //   path: "/participants/create/:id",
  //   name: "title.create_participant",
  //   component: ClientDetail,
  //   layout: "/admin",
  //   isMenu: false,
  //   permission: ADMIN_PERMISSIONS.clients.id
  // },
  {
    path: "/participants/:id",
    name: "title.participant_detail",
    component: ClientDetailTabs,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.clients.id
  },
  {
    path: "/complaints",
    name: "title.complaints",
    icon: {
      type: 'font-awesome',
      icon: 'fas fa-exclamation-circle'
    },
    component: ComplaintTable,
    layout: "/admin",
    isMenu: true,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/complaints/:id",
    name: "title.complaint_detail",
    component: ComplaintDetail,
    layout: "/admin",
    isMenu: false,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/action-register",
    name: "label.action_register",
    icon: {
      type: 'font-awesome',
      icon: 'far fa-check-square'
    },
    component: ActionRegisterTable,
    layout: "/admin",
    isMenu: true,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/incidents",
    name: "title.incidents",
    icon: {
      type: 'font-awesome',
      icon: 'fas fa-exclamation-triangle'
    },
    component: IncidentTable,
    layout: "/admin",
    isMenu: true,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/incidents/:id",
    name: "title.incident_detail",
    component: IncidentDetail,
    layout: "/admin",
    isMenu: false,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/investigations",
    name: "title.investigations",
    icon: SearchIcon,
    component: InvestigationTable,
    layout: "/admin",
    isMenu: true,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/investigations/:id",
    name: "title.investigation_detail",
    component: InvestigationDetail,
    layout: "/admin",
    isMenu: false,
    // permission: ADMIN_PERMISSIONS.complaints.id
  },
  {
    path: "/search-worker",
    name: "title.searchWorker",
    icon: {
      type: 'font-awesome',
      icon: 'fas fa-id-badge'
    },
    component: SearchWorker,
    layout: "/admin",
    // accessRole: [
    //   SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
    //   SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
    //   SYSTEM_ROLE.PARTICIPANT
    // ],
    isMenu: true,
    permission: ADMIN_PERMISSIONS.workers.id
  },
  {
    path: "/search-worker/detail/:id",
    name: "title.searchWorker",
    component: SearchWorkerDetail,
    layout: "/admin",
    // accessRole: [
    //   SYSTEM_ROLE.HOSPITAL_ADMIN, SYSTEM_ROLE.HOSPITAL_OTHER,
    //   SYSTEM_ROLE.COORDINATOR_ADMIN, SYSTEM_ROLE.COORDINATOR_OTHER,
    //   SYSTEM_ROLE.PARTICIPANT
    // ],
    permission: ADMIN_PERMISSIONS.workers.id
  },
  // {
  //   path: "/worker-profile/:id",
  //   name: "title.searchWorker",
  //   icon: SearchIcon,
  //   component: SearchWorkerDetail,
  //   activeStatus: true,
  //   layout: "/admin",
  //   accessRole: '*',
  //   isMenu: false,
  // },
  {
    path: "/jobs",
    name: "title.jobs",
    icon: ListIcon,
    component: JobManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.jobs.id
  },
  {
    path: "/jobs/create",
    name: "title.createNewJob",
    component: JobDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.jobs.id
  },
  {
    path: "/jobs/detail/:id",
    name: "title.jobDetails",
    component: JobDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.jobs.id
  },
  {
    path: "/booking",
    name: "title.shifts",
    extraTitle: "title.shifts",
    icon: EventAvailable,
    component: ClientBookingTable,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.booking.id
  },
  {
    path: "/booking/:id",
    name: "title.shiftDetails",
    icon: EventAvailable,
    component: ClientBookingDetail,
    layout: "/admin",
    permission: ADMIN_PERMISSIONS.booking.id
  },
  {
    path: "/financial/timesheet",
    parentName: "title.financial",
    name: "title.timesheet",
    subname: "title.timesheet",
    icon: AssessmentIcon,
    subIcon: AccessAlarmIcon,
    component: TimesheetManagement,
    layout: "/admin",
    isMenu: true,
    isSubMenu: true,
    permission: ADMIN_PERMISSIONS.payroll.id
  },
  {
    path: "/financial/timesheet/:id",
    name: "title.timesheetDetail",
    subname: "title.timesheetDetail",
    icon: AccessAlarmIcon,
    component: TimesheetDetail,
    layout: "/admin",
    // isMenu: true,
    // isSubMenu: true
    permission: ADMIN_PERMISSIONS.payroll.id
  },
  {
    path: "/billing",
    name: "title.billing",
    extraTitle: "title.billingList",
    icon: {
      type: 'font-awesome',
      icon: 'fas fa-file-invoice-dollar'
    },
    component: BillingManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.billing.id
  },
  {
    path: "/billing/:id",
    name: "title.billingDetails",
    icon: {
      type: 'font-awesome',
      icon: 'fas fa-file-invoice-dollar'
    },
    component: BillingDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.billing.id
  },
  {
    path: "/payroll",
    name: "label.payroll",
    icon: AttachMoney,
    component: PayrollManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.payroll.id
  },
  {
    path: "/payroll/:id",
    name: "label.payroll",
    icon: BarChart,
    component: PayrollDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.payroll.id
  },
  // {
  //   path: "/clients",
  //   name: "title.clients",
  //   extraTitle: "title.clients",
  //   icon: People,
  //   component: ClientManagement,
  //   layout: "/admin",
  //   isMenu: true,
  //   permission: ADMIN_PERMISSIONS.clients.id
  // },
  // {
  //   path: "/clients/create/:type",
  //   name: "title.create_client",
  //   component: ClientDetail,
  //   layout: "/admin",
  //   isMenu: false,
  //   permission: ADMIN_PERMISSIONS.clients.id
  // },
  // {
  //   path: "/clients/create/:type/:id",
  //   name: "title.create_client",
  //   component: ClientDetail,
  //   layout: "/admin",
  //   isMenu: false,
  //   permission: ADMIN_PERMISSIONS.clients.id
  // },
  // {
  //   path: "/clients/:id",
  //   name: "title.client_detail",
  //   component: ClientDetailTabs,
  //   layout: "/admin",
  //   isMenu: false,
  //   permission: ADMIN_PERMISSIONS.clients.id
  // },
  {
    path: "/rates",
    name: "label.rates",
    icon: BarChart,
    component: RateManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.rates.id
  },
  {
    path: "/rates/:type/create",
    name: "label.create_rates",
    icon: BarChart,
    component: RateDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.rates.id
  },
  {
    path: "/rates/:type/:id",
    name: "label.rates",
    icon: BarChart,
    component: RateDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.rates.id
  },

  {
    path: "/subscriptions",
    name: "label.subscriptionPlan",
    icon: SubscriptionsIcon,
    component: SubscriptionManagement,
    layout: "/admin",
    isMenu: true,
    permission: ADMIN_PERMISSIONS.subscriptions.id
  },
  {
    path: "/subscriptions/:id",
    name: "label.subscriptionPlan",
    icon: SubscriptionsIcon,
    component: SubscriptionDetail,
    layout: "/admin",
    isMenu: false,
    permission: ADMIN_PERMISSIONS.subscriptions.id
  },
  {
    path: "/setting-accounting",
    name: 'title.accounting_settings',
    icon: ConnectIcon,
    component: AccountingAccountForm,
    layout: '/admin',
    isMenu: true
  },
  {
    path: "/setting/account",
    name: "title.account_settings",
    parentName: "title.settings",
    subname: "title.account_settings",
    icon: SettingIcon,
    subIcon: SettingsAccount,
    component: AccountSetting,
    layout: "/admin",
    isSubMenu: true,
    isMenu: true
  },
  {
    path: "/settings/options",
    name: "label.options",
    parentName: "title.settings",
    subname: "label.options",
    icon: SettingIcon,
    subIcon: SettingsApplications,
    component: OptionManagement,
    layout: "/admin",
    isMenu: true,
    isSubMenu: true,
    permission: ADMIN_PERMISSIONS.options.id
  },

  // end company menus
];

export default dashboardRoutes;
